import { Button } from "@/components/ui/button"
import { Eye, Download, X } from "lucide-react"
import { type ExamPaper } from "@/lib/api"
import { api } from "@/lib/api"
import { PDFPreview } from "@/components/PDFPreview"

interface PaperPreviewPanelProps {
  paper: ExamPaper | null
  onClose: () => void
}

export function PaperPreviewPanel({ paper, onClose }: PaperPreviewPanelProps) {
  if (!paper) return null

  return (
    <div className="flex h-full flex-col bg-card overflow-hidden">
      {/* Header */}
      <div className="flex items-center justify-between border-b border-border p-4 flex-shrink-0">
        <div className="flex-1 min-w-0">
          <h3 className="font-semibold truncate">{paper.title}</h3>
          <p className="text-sm text-muted-foreground">
            {paper.year}年 · {paper.subject} · {paper.region}
          </p>
        </div>
        <Button
          variant="ghost"
          size="sm"
          onClick={onClose}
          className="ml-2 flex-shrink-0"
        >
          <X className="h-4 w-4" />
        </Button>
      </div>

      {/* PDF Preview */}
      <div className="flex-1 overflow-hidden p-4 min-h-0">
        {paper.id && <PDFPreview url={api.getPreviewUrl(paper.id)} />}
      </div>

      {/* Footer */}
      <div className="border-t border-border p-4 flex-shrink-0">
        <div className="flex items-center justify-between">
          <div className="flex gap-4 text-sm text-muted-foreground">
            <div className="flex items-center gap-1">
              <Eye className="h-4 w-4" />
              <span>{paper.views || 0}</span>
            </div>
            <div className="flex items-center gap-1">
              <Download className="h-4 w-4" />
              <span>{paper.downloads || 0}</span>
            </div>
          </div>
          <Button size="sm" asChild>
            <a
              href={paper.id ? api.getDownloadUrl(paper.id) : '#'}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Download className="mr-1 h-4 w-4" />
              下载
            </a>
          </Button>
        </div>
      </div>
    </div>
  )
}
